<template>
  <div class="text-comment-container">
    <div class="text-comment-content">
      <div class="comment-list-container">
        <div class="comment-header">
          <h1 class="comment-title">书写点评</h1>
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
          <div class="loading-text">正在获取最新点评...</div>
        </div>
        
        <!-- 点评列表 -->
        <div v-else-if="commentList.length > 0" class="comment-date-group">
          <div class="date-label">{{ formatTime(commentList[0].createTime) }}</div>
          <div class="comment-cards">
            <div 
              v-for="item in commentList" 
              :key="item.id" 
              class="comment-card"
              :class="{ 'deleting': deletingIds.has(item.id) }"
            >
              <div class="card-badge new">新</div>
              <div class="card-content">
                <div class="character-grid">
                  <img
                    :src="item.imgUrl"
                    alt="练字作品"
                    class="character-image"
                    @error="handleImageError"
                  />
                </div>
                <div class="card-action">
                  <img
                    src="../../assets/icon-delete-comment.png"
                    alt="删除点评"
                    class="delete-comment-btn"
                    @click.stop="deleteComment(item)"
                    title="删除点评"
                  />
                  <div class="open-comment-btn" @click="openComment(item)">
                    打开点评 ({{ getScoreGrade(item.score) }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 无数据状态 -->
        <div v-else class="no-data-container">
          <div class="no-data-text">暂无最新点评数据</div>
          <div class="no-data-subtitle">系统将每30秒自动刷新</div>
        </div>
      </div>
    </div>
    <bottom-bar right-bar="student"></bottom-bar>
    <comment-pop ref="comment-pop"></comment-pop>
    <pop-confirm ref="pop-confirm"></pop-confirm>
  </div>
</template>

<script>
import BottomBar from "../../components/BottomBar.vue";
import CommentPop from "../../components/CommentPop.vue";
import PopConfirm from "../../components/PopConfirm.vue";
export default {
  name: "WordSearch",
  components: {
    BottomBar,
    CommentPop,
    PopConfirm,
  },
  data() {
    return {
      wordVideoInfo: null,
      exampleInfo: null,
      commentList: [], // 点评列表数据
      loading: false, // 加载状态
      pollingTimer: null, // 轮询定时器
      userId: null, // 教师ID
      deletingIds: new Set(), // 正在删除的记录ID集合
    };
  },
  mounted() {
    // 初始化用户ID
    this.initUserId();
    
    // 开始轮询获取数据
    this.startPolling();
  },
  
  destroyed() {
    // 组件销毁时停止轮询
    this.stopPolling();
  },
  methods: {
    getScoreGrade(score) {
      if (!score) return '--'
      if (score > 90) return 'A+'
      if (score > 80) return 'A'
      if (score > 70) return 'A-'
      if (score > 60) return 'B+'
      if (score > 50) return 'B'
      if (score > 40) return 'B-'
      if (score > 30) return 'C+'
      if (score > 20) return 'C'
      return 'C-'
    },
    openComment(item) {
      // 传递点评数据给CommentPop组件
      this.$refs["comment-pop"].show(item);
    },
    
    // 获取AI点评推送数据
    async getAiCommentPush() {
      try {
        this.loading = true;
        const params = {};
        
        // 如果有教师ID，添加到参数中
        if (this.userId) {
          params.userId = this.userId;
        }
        
        const response = await this.$http.get('https://api.xiaobixiezi.com/teacher/public/aiCommentPush', {
          params: params
        });
        
        if (response && response.code === 200) {
          // 如果返回的data是数组，直接使用；如果是对象，转换为数组
          if (Array.isArray(response.data)) {
            this.commentList = response.data;
          } else if (response.data && response.data.exists) {
            // 根据API文档，data可能是单个对象
            this.commentList = [response.data];
          } else {
            this.commentList = [];
          }
          
          console.log('获取点评数据成功:', this.commentList);
        } else {
          console.error('获取点评数据失败:', response.msg);
          this.commentList = [];
        }
      } catch (error) {
        console.error('调用点评接口异常:', error);
        this.commentList = [];
      } finally {
        this.loading = false;
      }
    },
    
    // 开始轮询
    startPolling() {
      // 立即执行一次
      this.getAiCommentPush();
      
      // 每30秒轮询一次
      this.pollingTimer = setInterval(() => {
        this.getAiCommentPush();
      }, 30000);
    },
    
    // 停止轮询
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    
    // 格式化时间显示
    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    // 解析点评内容
    parseCommentContent(content) {
      try {
        if (typeof content === 'string') {
          return JSON.parse(content);
        }
        return content;
      } catch (error) {
        console.error('解析点评内容失败:', error);
        return { description: content || '暂无点评内容' };
      }
    },
    
    // 获取用户ID（可以从localStorage、sessionStorage或其他地方获取）
    initUserId() {
      // 这里需要根据实际项目获取教师ID的方式来实现
      this.userId = JSON.parse(sessionStorage.getItem('xiaobi_teacher')).id
    },
    
    // 处理图片加载错误
    handleImageError(event) {
      // 设置默认图片
      event.target.src = 'https://outin-9698ead669c111eab02000163e1a625e.oss-cn-shanghai.aliyuncs.com/image/default/AC3C433C80AC4CF38553C6A0A564FAAD-6-2.png';
    },
    
    // 删除点评
    async deleteComment(item) {
      // 防止重复点击
      if (this.deletingIds.has(item.id)) {
        return;
      }
      
      try {
        // 显示确认对话框
        const confirmed = await this.showDeleteConfirm();
        if (!confirmed) {
          return;
        }
        
        // 添加到删除中的集合
        this.deletingIds.add(item.id);
        
        console.log('删除点评:', item.id);
        
        // 调用删除接口
        const response = await this.$http({
          method: 'post',
          url: 'https://api.xiaobixiezi.com/teacher/public/deleteAiCommentPush',
          data: {
            id: item.id
          },
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response && response.code === 200) {
          // 删除成功，从列表中移除
          const index = this.commentList.findIndex(comment => comment.id === item.id);
          if (index > -1) {
            this.commentList.splice(index, 1);
          }
          
          // 显示成功提示
          this.$layer.msg('删除成功');
        } else {
          // 删除失败
          const errorMsg = response?.msg || '删除失败';
          this.$layer.msg(errorMsg);
        }
      } catch (error) {
        console.error('删除点评异常:', error);
        const errorMsg = '删除失败，请检查网络连接';
        this.$layer.msg(errorMsg);
      } finally {
        // 从删除中的集合移除
        this.deletingIds.delete(item.id);
      }
    },
    
    // 显示删除确认对话框
    showDeleteConfirm() {
      return new Promise((resolve) => {
        this.$refs["pop-confirm"].show({
          title: "",
          content: "确定要删除这条点评记录吗？",
          success: () => {
            resolve(true);
          },
          cancle: () => {
            resolve(false);
          }
        });
      });
    }
  },
};
</script>
<style scoped>
html {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.text-comment-container {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/class_bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 4rem;
}

.text-comment-content {
  width: 75rem;
  height: 40.54rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1.85rem 1.85rem 1.85rem 1.85rem;
  border: 0.1rem solid rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
  padding: 0.6rem;
}

.comment-list-container {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 0.6rem 1.2rem;
  box-sizing: border-box;
  border-radius: 1.2rem;
  overflow-y: auto;
}

.comment-header {
  margin-bottom: 0.6rem;
}

.comment-title {
  font-size: 1.54rem;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.comment-date-group {
  margin-bottom: 1rem;
}

.date-label {
  font-size: 0.8rem;
  color: #adb4c5;
  margin-bottom: 0.6rem;
  font-weight: 500;
}

.comment-cards {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.6rem;
}

.comment-card {
  position: relative;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.6rem;
  border: 0.04rem solid rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
}

.card-badge {
  position: absolute;
  top: -0.3rem;
  right: -0.3rem;
  background: #ff6b35;
  border: 2px solid #fff;
  color: white;
  font-size: 0.6rem;
  padding: 0.1rem 0.3rem;
  text-align: center;
  border-radius: 50%;
  z-index: 2;
}

.card-badge.new {
  background: #ff6b35;
}

.card-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.character-grid {
  position: relative;
}

.character-image {
  width: 100%;
  height: 15rem;
  object-fit: cover;
  border-radius: 0.3rem;
}

.card-action {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}

.delete-comment-btn {
  width: 1.6rem;
  height: 1.6rem;
}

.open-comment-btn {
  width: 100%;
  height: 1.6rem;
  background: #ffffff;
  color: #333333;
  border: none;
  border-radius: 0.8rem;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 滚动条样式 */
.comment-list-container::-webkit-scrollbar {
  width: 0rem;
}

.comment-list-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.15rem;
}

.comment-list-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 0.15rem;
}

.comment-list-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20rem;
  flex-direction: column;
}

.loading-text {
  font-size: 1rem;
  color: #666;
  margin-bottom: 1rem;
}

/* 无数据状态样式 */
.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20rem;
  flex-direction: column;
}

.no-data-text {
  font-size: 1.2rem;
  color: #999;
  margin-bottom: 0.5rem;
}

.no-data-subtitle {
  font-size: 0.9rem;
  color: #ccc;
}

/* 删除按钮悬停效果 */
.delete-comment-btn:hover {
  opacity: 0.7;
  cursor: pointer;
}

/* 打开点评按钮样式优化 */
.open-comment-btn:hover {
  background: #f0f0f0;
}

/* 删除中的卡片样式 */
.comment-card.deleting {
  opacity: 0.5;
  pointer-events: none;
  position: relative;
}

.comment-card.deleting::after {
  content: '删除中...';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.3rem;
  font-size: 0.9rem;
  z-index: 10;
}
</style>
